import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { AuthProvider, RequireAuth, RequireRole } from './lib/auth';
import { AdminInvoiceDetailPage } from './pages/AdminInvoiceDetail';
import { AdminInvoicesPage } from './pages/AdminInvoices';
import { DashboardPage } from './pages/Dashboard';
import { InvoiceDetailPage } from './pages/InvoiceDetail';
import { InvoiceNewPage } from './pages/InvoiceNew';
import { LoginPage } from './pages/Login';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="dashboard" element={<RequireAuth><DashboardPage /></RequireAuth>} />
          <Route path="invoices/new" element={<RequireAuth><InvoiceNewPage /></RequireAuth>} />
          <Route path="invoices/:invoiceId" element={<RequireAuth><InvoiceDetailPage /></RequireAuth>} />
          <Route path="admin">
            <Route index element={<Navigate to="/admin/invoices" replace />} />
            <Route path="invoices" element={<RequireRole role="admin"><AdminInvoicesPage /></RequireRole>} />
            <Route path="invoices/:invoiceId" element={<RequireRole role="admin"><AdminInvoiceDetailPage /></RequireRole>} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

function NotFound() {
  return (
    <div>
      <h1>Not found</h1>
      <p>This page does not exist.</p>
    </div>
  );
}
